export enum NotificationType {
    EmailNotification,
    WebNotification,
    SmsNotification
}